import Immutable from 'immutable';

import SortOrder from 'sharedreact/data/SortOrder';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import ItemsState from 'sharedreact/stores/generic/ItemsState';
import ItemsStore from 'sharedreact/stores/generic/ItemsStore';

import AgentsActions from 'workspaces/launcher/actions/AgentsActions';
import AgentsConstants from 'workspaces/launcher/constants/AgentsConstants';
import Agent from 'workspaces/launcher/data/Agent';

import type { ActionType } from 'sharedreact/actions/generic/actions';

class AgentsStore extends ItemsStore<Agent> {
  constructor () {
    super(AppDispatcher, AgentsActions, AgentsConstants);
  }

  getInitialSortOrder (): SortOrder {
    return new SortOrder({keyword: 'name', ascending: true});
  }

  getSecondarySortKeyword (): string {
    return 'name';
  }

  getSortKeywords (): string[] {
    return ['name', 'status', 'version'];
  }

  override reduce (state: ItemsState<Agent>, action: ActionType): ItemsState<Agent> {
    switch (action.actionType) {
      case AgentsConstants.REMOVE: {
        return state
          .set('items', state.items.clear())
          .set('mappedItems', state.mappedItems.clear())
          .set('isFetching', true);
      }
      case AgentsConstants.REMOVE_SUCCESS: {
        if (!action.ids) {
          return state;
        }

        // Item was removed, so clear local items and reload from server.
        if (this._isStoreActive) {
          state = this._fetchAll(state)
            .set('items', state.items.clear())
            .set('mappedItems', state.mappedItems.clear())
            .set('selection', Immutable.Set());
        }

        return state;
      }
      case AgentsConstants.REMOVE_FAIL: {
          return state.set('isFetching', false);
      }
      default: {
        // handle all other actions like the generic ItemsStore would
        return super.reduce(state, action);
      }
    }
  }
}

export default new AgentsStore();
